const toText = (value) => (value === undefined || value === null ? "" : `${value}`);

const getStringValue = (value) => {
  if (typeof value === "string") {
    return value;
  }

  if (!value || typeof value !== "object") {
    return "";
  }

  const candidateKeys = ["file_url", "url", "sign_url", "path", "file_path", "file_base_path", "files_path"];
  for (let index = 0; index < candidateKeys.length; index += 1) {
    const candidateValue = value[candidateKeys[index]];
    if (typeof candidateValue === "string") {
      return candidateValue;
    }
  }

  return "";
};

const joinFilePath = (basePath = "", relativePath = "") => {
  const resolvedBasePath = getStringValue(basePath);
  const resolvedRelativePath = getStringValue(relativePath);
  const normalizedBasePath = resolvedBasePath ? resolvedBasePath.replace(/\/+$/, "") : "";
  const normalizedRelativePath = resolvedRelativePath ? resolvedRelativePath.replace(/^\/+/, "") : "";

  if (!normalizedRelativePath) {
    return "";
  }

  if (!normalizedBasePath) {
    return normalizedRelativePath;
  }

  return `${normalizedBasePath}/${normalizedRelativePath}`;
};

export const getHeadingContentByKey = (headingContents = [], headingKey = "") => {
  if (!Array.isArray(headingContents) || !headingKey) {
    return "";
  }

  const matchedHeading = headingContents.find((item) => item && item.heading_key === headingKey);
  return matchedHeading && typeof matchedHeading.heading_content === "string" ? matchedHeading.heading_content : "";
};

export const getResolvedChecklistHeadingContent = (checklist = {}, headingKey = "") => {
  if (!checklist || !headingKey) {
    return "";
  }

  const topLevelValue = checklist && typeof checklist[headingKey] === "string"
    ? checklist[headingKey]
    : "";

  if (topLevelValue) {
    return topLevelValue;
  }

  const nestedDataValue = checklist
    && checklist.data
    && typeof checklist.data === "object"
    && typeof checklist.data[headingKey] === "string"
      ? checklist.data[headingKey]
      : "";

  return nestedDataValue || "";
};

export const resolveParticipantName = (participant = {}) => {
  if (participant && participant.staff_name) {
    return participant.staff_name;
  }

  if (participant && participant.added_on_the_fly && participant.added_person_name) {
    return participant.added_person_name;
  }

  return "";
};

export const getAnswerByQuestionId = (answers = [], questionId) => {
  if (!Array.isArray(answers)) {
    return null;
  }

  return answers.find((answer) => Number(answer && answer.question_id) === Number(questionId)) || null;
};

export const formatAnswerValue = (question = {}, answer = null, filesPath = "") => {
  if (!answer) {
    return "";
  }

  const responseConfig = question && question.response_config ? question.response_config : {};
  const responseType = responseConfig.type;
  const rawValue = answer.value;

  if (rawValue === undefined || rawValue === null || rawValue === "") {
    return "";
  }

  if (responseType === "radio") {
    const options = Array.isArray(responseConfig.options) ? responseConfig.options : [];
    const matchedOption = options.find((option) => option && option.value === rawValue);
    return matchedOption && matchedOption.label ? matchedOption.label : toText(rawValue);
  }

  if (responseType === "number") {
    const unit = responseConfig && typeof responseConfig.unit === "string" ? responseConfig.unit.trim() : "";
    return unit ? `${toText(rawValue)} ${unit}` : toText(rawValue);
  }

  if (responseType === "signature" || responseType === "photo") {
    if (typeof rawValue === "string") {
      return rawValue;
    }

    if (rawValue && typeof rawValue === "object") {
      const resolvedFileUrl = getStringValue(rawValue.file_url || rawValue);
      const resolvedUrl = resolvedFileUrl
        ? joinFilePath(filesPath, resolvedFileUrl)
        : getStringValue(rawValue);

      if (resolvedFileUrl) {
        return resolvedUrl;
      }

      return resolvedUrl;
    }
  }

  return toText(rawValue);
};
